import { animate, style, transition, trigger } from '@angular/animations';

export const scaleInOut = trigger('scaleInOut', [
  transition(
    ':enter', [
      style({ transform: 'translateX(-50%) translateY(-50%) scale(.7)', opacity: 0 }),
      animate('0.2s', style({ opacity: 1, transform: 'translateX(-50%) translateY(-50%) scale(1)' })),
    ]
  ),
  transition(
    ':leave', [
      style({ opacity: 1, transform: 'translateX(-50%) translateY(-50%) scale(1)' }),
      animate('0.2s', style({ opacity: 0, transform: 'translateX(-50%) translateY(-50%) scale(.7)' })),
    ]
  ),
]);
